module.exports = __webpack_public_path__ + "img/logo2.1bf41e86.svg";